export const STARTER_KIT_PRODUCT_LABEL = 'Chat Starter Kit V1.0';

export function resolveProjectDisplayName(project, apiData) {
  const cardName = [project?.name, project?.config?.name]
    .map((value) => String(value || '').trim())
    .find(Boolean);
  if (cardName) return cardName;

  const apiName = String(apiData?.project_name || '').trim();
  const projectId = String(project?.project_id || apiData?.project_id || '').trim();
  return apiName || projectId || 'Selected project';
}

export const KIT_STATE_NOT_ISSUED = 'not_issued';
export const KIT_STATE_PENDING = 'pending';
export const KIT_STATE_ACTIVE = 'active';

export const KIT_ICON_NEUTRAL = 'neutral';
export const KIT_ICON_PENDING = 'pending';
export const KIT_ICON_DOWNLOADED = 'downloaded';

export function buildEntitlementsByProjectId(entitlements) {
  const map = {};
  (entitlements || []).forEach((row) => {
    const projectId = row?.project_id;
    if (!projectId) return;
    const existing = map[projectId];
    if (!existing) {
      map[projectId] = row;
      return;
    }
    const existingTs = new Date(existing.updated_at || existing.created_at || 0).getTime();
    const rowTs = new Date(row.updated_at || row.created_at || 0).getTime();
    if (rowTs >= existingTs) {
      map[projectId] = row;
    }
  });
  return map;
}

export function getProjectKitState(entitlementsByProjectId, projectId) {
  const row = entitlementsByProjectId?.[projectId];
  if (!row) return KIT_STATE_NOT_ISSUED;
  if (row.status === 'active') return KIT_STATE_ACTIVE;
  if (row.status === 'pending') return KIT_STATE_PENDING;
  return KIT_STATE_NOT_ISSUED;
}

export function getStarterKitActionLabel(kitState) {
  if (kitState === KIT_STATE_NOT_ISSUED) return 'Generate Starter Kit ZIP';
  return 'Regenerate ZIP + Token';
}

export function getStarterKitIconVisualState(entitlementsByProjectId, projectId) {
  const row = entitlementsByProjectId?.[projectId];
  if (!row) return KIT_ICON_NEUTRAL;
  if (row.status === 'active') return KIT_ICON_DOWNLOADED;
  if (row.status === 'pending') return KIT_ICON_PENDING;
  return KIT_ICON_NEUTRAL;
}

export function getStarterKitIconTooltip(entitlementsByProjectId, projectId) {
  const row = entitlementsByProjectId?.[projectId];
  const iconVisualState = getStarterKitIconVisualState(entitlementsByProjectId, projectId);
  if (iconVisualState === KIT_ICON_PENDING) {
    if (row?.downloaded_at) {
      return 'Pending — Regenerate Starter Kit';
    }
    return 'Pending — Regenerate Starter Kit';
  }
  if (iconVisualState === KIT_ICON_DOWNLOADED) {
    return 'Activated — Regenerate Starter Kit';
  }
  return 'Generate starter kit';
}

/** Download for first issue; reload/regenerate once a kit exists or is pending. */
export function getStarterKitIconType(iconVisualState) {
  return iconVisualState === KIT_ICON_NEUTRAL ? 'download' : 'reload';
}

export function getStarterKitWrapClassName(iconVisualState) {
  const base = 'project-starter-kit-btn-wrap';
  if (iconVisualState === KIT_ICON_PENDING) {
    return `${base} project-starter-kit-btn-wrap--pending`;
  }
  if (iconVisualState === KIT_ICON_DOWNLOADED) {
    return `${base} project-starter-kit-btn-wrap--downloaded`;
  }
  return base;
}

/** Button shell stays neutral; only the wrap dot reflects pending/active state. */
export function getStarterKitIconClassName() {
  return 'project-starter-kit-btn';
}
